<template>
  <div class="
      grid
      home-values-container
      mt-16
      mb-32
      grid-cols-5
      layout-padding
      rounded-2xl
    ">
    <div class="col-span-5 mb-6 md:mb-0 lg:col-span-2 relative">
      <div 
        ref="imageElement"
        class="home-values-image w-full z-10 rounded-3xl image-animate"
        :class="{ 'animate-in': imageVisible }"
        :style="`background: url(${values[0].image})`"
      >
        <div class="p-8">
          <div 
            class="home-values-bordr border-animate"
            :class="{ 'animate-in': imageVisible }"
          ></div>
        </div>
      </div>
    </div>
    <div class="col-span-5 lg:col-span-3 flex flex-col justify-center">
      <div class="lg:pl-32 pl-0">
        <div 
          ref="titleElement"
          class="text-safetyBlack text-8xl title-animate"
          :class="{ 'animate-in': titleVisible }"
        >
          {{ content.ourValues }}
        </div>
        <div 
          ref="descriptionElement"
          class="text-xl mt-8 description-animate paragraph"
          :class="{ 'animate-in': descriptionVisible }"
        >
          {{ values[0].description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["values"],
  inject: ["content"],
  data() {
    return {
      imageVisible: false,
      titleVisible: false,
      descriptionVisible: false,
      observer: null,
    };
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: "0px 0px -100px 0px",
        threshold: 0.1,
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target;
            
            // Add staggered delays for sequential animation
            if (element === this.$refs.imageElement) {
              setTimeout(() => {
                this.imageVisible = true;
              }, 100);
            } else if (element === this.$refs.titleElement) {
              setTimeout(() => {
                this.titleVisible = true;
              }, 200);
            } else if (element === this.$refs.descriptionElement) {
              setTimeout(() => {
                this.descriptionVisible = true;
              }, 400);
            }
          }
        });
      }, options);

      this.observeElements();
    },
    
    observeElements() {
      this.$nextTick(() => {
        setTimeout(() => {
          const elementsToObserve = [
            this.$refs.imageElement,
            this.$refs.titleElement,
            this.$refs.descriptionElement
          ];

          elementsToObserve.forEach(element => {
            if (element && element instanceof Element && this.observer) {
              this.observer.observe(element);
            }
          });
        }, 100);
      });
    },
  },
};
</script>

<style scoped>
/* Base animation styles */
.image-animate,
.title-animate,
.description-animate,
.border-animate {
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Image animation */
.image-animate {
  transform: translateX(-50px) scale(0.95);
}

.image-animate.animate-in {
  opacity: 1;
  transform: translateX(0) scale(1);
}

/* Border animation */
.border-animate {
  transform: scale(0.8);
  transition-delay: 0.3s;
}

.border-animate.animate-in {
  opacity: 1;
  transform: scale(1);
}

/* Title animation */
.title-animate {
  transform: translateY(40px);
}

.title-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Description animation */
.description-animate {
  transform: translateY(20px);
}

.description-animate.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .image-animate {
    transform: translateY(30px) scale(0.98);
  }
  
  .image-animate.animate-in {
    transform: translateY(0) scale(1);
  }
}
</style>